/* eslint-disable react/no-direct-mutation-state */
/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Header from './header'
import Menu from './menu'
import WebMultiMarket from './sub_components/webmultimarket'
import WinnerOdds from './sub_components/multiWinnerOdds'
import Toast from './sub_components/toast'
import ExpoPopup from './sub_components/expoPopup';
import BetSlipPopup from './sub_components/betSlipPopup';
import MultiFancybook from './multiFancybook'
import * as eventService from '../services/eventService'
import * as orderService from '../services/orderService'
import * as stringParser from '../util/string.util'
import * as dateUtil from '../util/date.util'
import { staticContentsImagePath as BASE_IMAGE_PATH } from '../configs/const';
import { calculateBetExpouser, calculateFancyMktExpouser, calculateFancyMktExpouserDemo } from '../util/expouser.util';

let mBets = []
let umBets = []
let formInterval
let socket = null
let dataLoader = null
class MultiMarket extends Component {
    constructor(props) {
        super(props);
        this.state = {
            game: {},
            event: {},
            gameCode: "",
            selected_market: "",
            selcted_bet_option: "",
            matched_bet: [],
            unmatched_bet: [],
            selected_list: "matched",
            selected_game_code: "",
            selected_event_code: "",
            pinnedEvents: [],
            selectedEvents: [],
            showToast: false,
            toastMsg: "",
            toastType: "",
            loading: true,
            loadingBet: false,
            mktFeedBooks: {},
            showExpo: false,
            lineExpo: {},
            betLimit: 20,
            betSlipOpen: false,
            deactivatMarkets: [],
            deactivatOrders: [],
            evetList: [],
            subscribedMarkets: [],
            betPlaced: false
        };
    }
    updateBook(marketId, book) {
        let feedBooks = this.state.mktFeedBooks
        feedBooks[marketId] = book
        this.state.mktFeedBooks = feedBooks
    }
    async componentDidMount() {
        localStorage.removeItem("betForm");
        localStorage.removeItem("betExpo");
        let pinnedEvents = localStorage.getItem("pinnedEvents")

        let userData = localStorage.getItem("tokenData")
        userData = JSON.parse(userData)
        if(!!userData && userData.role === 'DemoClient'){
            socket.on("demo_room", async (data) => {
                let msg = JSON.parse(data);
                if (!!msg.command && ["MARKET_RESULT","MARKET_VOID"].includes(msg.command)) {
                    let demoIdSsData = this.state.matched_bet;
                    let betindex = -1;
                    
                    for(let i=0; i<demoIdSsData.length;i++){
                        if(demoIdSsData[i].marketId === msg.payload.message.marketId){
                            betindex = i;
                            break;
                        }
                    } 

                    if(betindex >-1){
                        demoIdSsData.splice(betindex,1);
                        this.setState({matched_bet:demoIdSsData})
                    }

                    // msg.payload
                }
            })
        }
    

        let userEventData = await eventService.getMarketsById(pinnedEvents)
        let events = []
        !!userEventData && userEventData.length > 0 && userEventData.forEach((mkt, i) => {
            if (!mkt) {
                return false
            }
            let market = { ...mkt.catalogue, ...mkt.marketCondition }
            if (!!mkt.metadata.book && mkt.metadata.book !== null) {
                let eventMeta = {}
                eventMeta.hasBookmaker = !!mkt.metadata && !!mkt.metadata.hasBookmaker && mkt.metadata.hasBookmaker === "True" ? "true" : "false"
                eventMeta.hasSession = !!mkt.metadata && !!mkt.metadata.hasSession && mkt.metadata.hasSession === "True" ? "true" : "false"
                eventMeta.hasTv = !!mkt.metadata && !!mkt.metadata.hasTv && mkt.metadata.hasTv === "True" ? "true" : "false"
                market.metadata = { "book": stringParser.deSrlz(mkt.metadata.book) }
                market.marketBook = !!market.metadata && !!market.metadata.book ? market.metadata.book : null
                market.metadata.eventMeta = eventMeta

                if (mkt.eventType.id === "300") {
                    market.displayMarketNameTime = dateUtil.getBinaryMarketDisplayName(mkt.catalogue.marketName)
                    market.symbolType = !!mkt.metadata && !!mkt.metadata.symbol_type ? mkt.metadata.symbol_type : null
                    market.eventId = mkt.event.id
                    market.eventName = mkt.event.name
                    market.competitionName = mkt.competition.name
                }
            } else {
                let baseData = {
                    marketId: market.marketId,
                    status: "OPEN",
                    runners: []
                }
                market.runners.forEach((rnr) => {
                    let data = { "selectionId": rnr.id.toString(), "status": "ACTIVE", "back": [{ "price": 0, "size": 0, "line": 0 }, { "price": 0, "size": 0, "line": 0 }, { "price": 0, "size": 0, "line": 0 }], "lay": [{ "price": 0, "size": 0, "line": 0 }, { "price": 0, "size": 0, "line": 0 }, { "price": 0, "size": 0, "line": 0 }] }
                    baseData.runners.push(data)
                })
                market.marketBook = baseData
            }
            if (market.status === "OPEN" && market.marketBook === null) {
                let baseData = {
                    marketId: mkt.catalogue.marketId,
                    status: "OPEN",
                    runners: []
                }
                market.runners.forEach((rnr) => {
                    let data = { "selectionId": rnr.id.toString(), "status": "ACTIVE", "back": [{ "price": "0", "size": "0", "line": "0" }, { "price": "0", "size": "0", "line": "0" }, { "price": "0", "size": "0", "line": "0" }], "lay": [{ "price": "0", "size": "0", "line": "0" }, { "price": "0", "size": "0", "line": "0" }, { "price": "0", "size": "0", "line": "0" }] }
                    baseData.runners.push(data)
                })
                market.marketBook = baseData
            }
            market.marketId = mkt.catalogue.marketId
            if (market.provider !== "BETHUBS") {
                if (!market.marketBook || mkt.status === "CLOSED" || market.marketBook.status === "CLOSED" || market.marketBook.status === "INACTIVE" || !market.marketBook.runners || market.marketBook.runners.length < 1) {
                    return false
                }
            }
            let evt = mkt.event
            evt.eventTypeId = mkt.eventType.id
            evt.eventType = mkt.eventType
            // evt.eventType = mkt.eventType.name
            evt.competitionId = mkt.competition.id
            evt.compititionName = mkt.competition.name
            evt.markets = [market]
            events.push(evt)
        })
        events = events.sort(function (a, b) {
            return new Date(b.openDate) - new Date(a.openDate);
        }).reverse();

        let mmEvents = events
        mmEvents.forEach((evt, i) => {
            var moPos = evt.markets.findIndex(function (mkt) { return mkt.provider === "BETFAIR" && mkt.marketType === "MATCH_ODDS" });
            if (moPos !== -1) {
                let mom = [evt.markets[moPos]]
                mmEvents[i].markets = mom
            }
        })
        let evtList = mmEvents.map(ev => ev.id)
        let mkts = !!pinnedEvents ? pinnedEvents.split(",") : []
        await eventService.getMatchedBets({ "id": evtList.toString() }).then((res) => {
            if (!!res && res.isSuccess) {
                mBets = []
                let userData = localStorage.getItem("tokenData")
                userData = JSON.parse(userData)
                if(!!userData && userData.role === 'DemoClient'){
                    let demoIdSsData = sessionStorage.getItem('demoIdSsData');
                    demoIdSsData = !!demoIdSsData ? JSON.parse(demoIdSsData) : null;
                    if(!!demoIdSsData){
                        Object.keys(demoIdSsData).forEach((itmm)=>{
                            demoIdSsData[itmm].forEach((itm)=>{
                                mBets.push(itm);
                            })
                        })
                        // mBets = Object.values(demoIdSsData)
                    }
                } else {
                    res.items.forEach((bet) => {
                        if (bet.marketBettingType === "LINE") {
                            bet.runnerName = bet.marketName
                        }
                        if (mkts.indexOf(bet.marketId) > -1) {
                            mBets.push(bet)
                        }
                    })
                }
            }
        })
        // mBets = mBets.reverse()
        this.setState({ selectedEvents: [], matched_bet: [] }, () => {
            this.setState({ selectedEvents: mmEvents, matched_bet: mBets, unmatched_bet: umBets, pinnedEvents: pinnedEvents, loading: false, evetList: evtList })
        })
        dataLoader = setInterval(() => { this.loadData() }, 10000)
    }
    componentWillUnmount() {
        mBets = []
        this.setState({ matched_bet: [] })
        clearInterval(dataLoader)
        
        if(!!this.props.socket){
            this.props.socket.off("demo_room");
        }
    }
    async loadData() {
        let pinnedEvents = localStorage.getItem("pinnedEvents")
        let userEventData = await eventService.getMarketsById(pinnedEvents)
        let events = []
        !!userEventData && userEventData.length > 0 && userEventData.forEach((mkt, i) => {
            if (!mkt) {
                return false
            }
            let market = { ...mkt.catalogue, ...mkt.marketCondition }
            if (!!mkt.metadata.book && mkt.metadata.book !== null) {
                // market.metadata = { "book": stringParser.deSrlz("book|" + mkt.metadata.book) }
                market.metadata = { "book": JSON.parse(mkt.metadata.book) }
                market.marketBook = !!market.metadata && !!market.metadata.book ? market.metadata.book : null
            } else {
                let baseData = {
                    marketId: market.marketId,
                    status: "OPEN",
                    runners: []
                }
                market.runners.forEach((rnr) => {
                    let data = { "selectionId": rnr.id.toString(), "status": "ACTIVE", "back": [{ "price": 0, "size": 0, "line": 0 }, { "price": 0, "size": 0, "line": 0 }, { "price": 0, "size": 0, "line": 0 }], "lay": [{ "price": 0, "size": 0, "line": 0 }, { "price": 0, "size": 0, "line": 0 }, { "price": 0, "size": 0, "line": 0 }] }
                    baseData.runners.push(data)
                })
                market.marketBook = baseData
            }
            if (market.status === "OPEN" && market.marketBook === null) {
                let baseData = {
                    marketId: mkt.catalogue.marketId,
                    status: "OPEN",
                    runners: []
                }
                market.runners.forEach((rnr) => {
                    let data = { "selectionId": rnr.id.toString(), "status": "ACTIVE", "back": [{ "price": "0", "size": "0", "line": "0" }, { "price": "0", "size": "0", "line": "0" }, { "price": "0", "size": "0", "line": "0" }], "lay": [{ "price": "0", "size": "0", "line": "0" }, { "price": "0", "size": "0", "line": "0" }, { "price": "0", "size": "0", "line": "0" }] }
                    baseData.runners.push(data)
                })
                market.marketBook = baseData
            }
            market.marketId = mkt.catalogue.marketId
            if (market.provider !== "BETHUBS") {
                if (!market.marketBook || mkt.status === "CLOSED" || market.marketBook.status === "CLOSED" || market.marketBook.status === "INACTIVE" || !market.marketBook.runners || market.marketBook.runners.length < 1) {
                    return false
                }
            }
            let evt = mkt.event
            evt.eventTypeId = mkt.eventType.id
            evt.eventType = mkt.eventType
            // evt.eventType = mkt.eventType.name
            evt.competitionId = mkt.competition.id
            evt.compititionName = mkt.competition.name
            evt.markets = [market]
            events.push(evt)
        })
        events = events.sort(function (a, b) {
            return new Date(b.openDate) - new Date(a.openDate);
        }).reverse();

        let mmEvents = events
        mmEvents.forEach((evt, i) => {
            var moPos = evt.markets.findIndex(function (mkt) { return mkt.provider === "BETFAIR" && mkt.marketType === "MATCH_ODDS" });
            if (moPos !== -1) {
                let mom = [evt.markets[moPos]]
                mmEvents[i].markets = mom
            }
        })
        this.setState({ selectedEvents: [] }, () => {
            this.setState({ selectedEvents: mmEvents, pinnedEvents: pinnedEvents, loading: false })
        })
    }
    detectMob() {
        const toMatch = [
            "/Android/i",
            "/webOS/i",
            "/iPhone/i",
            "/iPad/i",
            "/iPod/i",
            "/BlackBerry/i",
            "/Windows Phone/i"
        ];
        return toMatch.some((toMatchItem) => {
            return navigator.userAgent.match(toMatchItem);
        });
    }
    checkingetzero(txt){
        return txt.toString().length === 1 ? '0' : '';
    }

    addDemoBet(bet, prfdt){
        const crdt = new Date();
        const crdtat = `${crdt.getFullYear()}-${this.checkingetzero(crdt.getMonth())}${crdt.getMonth()}-${this.checkingetzero(crdt.getDate())}${crdt.getDate()}T${this.checkingetzero(crdt.getHours())}${crdt.getHours()}:${this.checkingetzero(crdt.getMinutes())}${crdt.getMinutes()}:${this.checkingetzero(crdt.getSeconds())}${crdt.getSeconds()}Z`;
        let demoExpo = sessionStorage.getItem('demoExpo')
        let totalexpo = 0
            if(!!demoExpo && demoExpo !== 'null' && Object.keys(demoExpo).length > 0){
                demoExpo = JSON.parse(demoExpo);
                totalexpo = (Object.values(demoExpo).reduce((a,v) =>  a = a + v , 0 ))
            }
        let resdata = {
            "provider": bet?.market?.provider,
            "orderId": crdt.getTime(),
            "orderType": "LIMIT",
            "eventId": this.props.match.params.event_id,
            "marketId": bet?.marketId,
            "marketName": bet?.market?.marketName,
            "marketType": bet?.market?.marketType,
            "marketBettingType": bet?.market?.bettingType,
            "side": bet?.bet_for?.toUpperCase(),
            // "runnerId": bet.selectionId,
            // "runnerName": "Papua New Guinea",
            "price": bet?.price,
            "amount": !!bet ? parseInt(bet.bet_amount):0,
            "runnersExposure": {
                // "247649": {
                //     "runnerId": 247649,
                //     "exposure": -100,
                //     "sharingUp": -100,
                //     "sharingMe": 0,
                //     "sharingDown": 0
                // },
                // "2857977": {
                //     "runnerId": 2857977,
                //     "exposure": 8,
                //     "sharingUp": 8,
                //     "sharingMe": 0,
                //     "sharingDown": 0
                // }
            },
            "subscriber": prfdt.userId,
            "baseAmount": bet?.bet_amount,
            "createdAt": crdtat,
            "operatorId": prfdt.operatorId,
            "username": prfdt.username,
            "currency": prfdt.currency,
            "currencyConversion": prfdt.currencyConversion,
            "userId": prfdt.userId
        };
        let btexp = 0;
        if(bet?.market?.bettingType === "LINE"){
            resdata['runnerId'] = bet?.market?.metadata?.book?.runners[0][bet.bet_for][0].line
            resdata['runnerName'] = bet?.market?.metadata?.book?.runners[0][bet.bet_for][0].line
            let btarr = [];
            btarr.push(resdata);
            let betexpo = calculateFancyMktExpouserDemo(bet.market, btarr);
            btexp = betexpo.expo;
        } else {

            let betexpo = calculateBetExpouser(bet.market,bet.market.runners,bet?.bet_for?.toLowerCase(),bet.bet_amount,bet.price,true)
            bet?.market?.runners.forEach((itm)=>{
                resdata['runnersExposure'][itm.id] = {};
                resdata['runnersExposure'][itm.id]["runnerId"]= itm.id;
                resdata['runnersExposure'][itm.id]["name"]= itm.name;
                resdata['runnersExposure'][itm.id]["exposure"]= betexpo[itm.id];
                resdata['runnersExposure'][itm.id]["sharingUp"]= 0;
                resdata['runnersExposure'][itm.id]["sharingMe"]= 0;
                resdata['runnersExposure'][itm.id]["sharingDown"]=0;
            })
            resdata['runnerId'] = bet?.selectionId; //resdata['runnersExposure'][bet?.selectionId]["runnerId"];
            resdata['runnerName'] = resdata['runnersExposure'][bet?.selectionId]["name"];
            let expvlarr = Object.values(betexpo)
            btexp = Math.min(...expvlarr);
        }
        // totalexpo = totalexpo + (bet?.market?.bettingType === "LINE" ? 0 : btexp);
        totalexpo = totalexpo + btexp;
        const profData = JSON.parse(localStorage.getItem('profData'));
        let demopl = sessionStorage.getItem('demoPnL')

        let availableBal = profData.balance + totalexpo + (!!demopl ? demopl : 0);
        if(availableBal < 0){
            this.props.notify("Not Enough Balance", "error")
            this.setState({selected_market: "", selcted_bet_option: "", loadingBet: false });
            if(bet?.market?.bettingType === "LINE"){
                // demoExpo[bet?.marketId] = demoExpo[bet?.marketId] - btexp;
                // sessionStorage.setItem('demoExpo',JSON.stringify(demoExpo));
                document.getElementById('btnHdnRecalculateDemoExpo').click();
            }
        } else {
            let res={
                isSuccess: true,
                data: resdata
            }
            this.onOrderPlaced(res, bet);
            // this.setState({ loadingBet: true },()=>{
            //     setTimeout(() => {
            //         // this.setState({ loadingBet: false },()=>{

            //         // })    
            //         this.onOrderPlaced(res);
            //     }, 3000);
            // })
        }
    }

    addBet(bet, event) {
        const prfdt = JSON.parse(localStorage.getItem('profData'));
        if(prfdt.role === 'DemoClient'){
            // debugger;
            this.addDemoBet(bet, prfdt);
        } else {
            this.setState({ loadingBet: true })
            let betData = JSON.parse(localStorage.getItem("betForm"))
            let body = {
                marketId: bet.marketId,
                placeInstruction: {
                    orderType: "LIMIT",
                    selectionId: parseFloat(betData.selectionId),
                    side: !!bet.bet_for ? bet.bet_for.toUpperCase() : 'UNKNOWN',
                    limitOrder: {
                        size: parseFloat(parseFloat(betData.bid_amount.toString()).toFixed(2)),
                        price: parseFloat(parseFloat(betData.bid_at.toString()).toFixed(2)),
                        persistenceType: "PERSIST"
                    }
                }
            }
            if (!!betData.bid_line && betData.bid_line > 0) {
                body.placeInstruction.selectionId = betData.bid_line
            }
            if (bet.market.bettingType === "BOOKMAKER") {
                orderService.placeBMOrder(body).then((res) => { this.onOrderPlaced(res, bet) })
            } else if (bet.market.bettingType === "LINE") {
                orderService.placeLineOrder(body).then((res) => { this.onOrderPlaced(res, bet) })
            } else if (bet.market.bettingType === "ODDS") {
                orderService.placeOddsOrder(body).then((res) => { this.onOrderPlaced(res, bet) })
            }
            // orderService.placeOrder(body).then((res) => {
            //     if (res.isSuccess !== false && !res.errors) {
            //         if (!!res.exception && !!res.exception.message) {
            //             this.props.notify(res.exception.message, "error")
            //         } else {
            //             this.props.notify("Bet Placed Successfully !", "success")
            //             if (!!res.data && Object.keys(res.data).length > 0) {
            //                 this.orderPlaced(res.data)
            //             }
            //         }
            //         setTimeout(() => {
            //             this.setState({ selected_market: "", selcted_bet_option: "", loadingBet: false })
            //         }, bet.market.betDelay)
            //     } else {
            //         this.props.notify(!!res.exception && !!res.exception.message ? res.exception.message : "Bet failed due to mismatch data.", "error")
            //         this.setState({ selected_market: "", selcted_bet_option: "", loadingBet: false })
            //     }
            // })
        }
    }
    onOrderPlaced(res, bet) {
        if (res.isSuccess !== false && !res.errors) {
            if (!!res.exception && !!res.exception.message) {
                this.props.notify(res.exception.message, "error")
            } else {
                this.props.notify("Bet Placed Successfully !", "success")
                if (!!res.data && Object.keys(res.data).length > 0) {
                    this.orderPlaced(res.data)
                }
            }
            setTimeout(() => {
                this.setState({ selected_market: "", selcted_bet_option: "", loadingBet: false })
            }, bet.market.betDelay)
        } else {
            this.props.notify(!!res.exception && !!res.exception.message ? res.exception.message : "Bet failed due to mismatch data.", "error")
            this.setState({ selected_market: "", selcted_bet_option: "", loadingBet: false })
        }
    }
    showToast(msg, type) {
        let self = this
        this.setState({ toastMsg: msg, toastType: type, showToast: true }, () => {
            setTimeout(() => {
                self.setState({ toastMsg: "", toastType: "", showToast: false })
            }, 3000);
        })
    }
    showExpo(data) {
        this.setState({ showExpo: true, lineExpo: data })
    }
    hidePopup() {
        this.setState({ showExpo: false, betSlipOpen: false, lineExpo: {} })
    }
    betForm(market, bet, clicked) {
        let self = this
        if (this.state.loadingBet === true) {
            return false
        }
        this.setState({ selected_market: market, selcted_bet_option: bet }, () => {
            if (market !== null && bet !== null && clicked) {
                if (window.innerWidth > 767) {
                    let screenHeight = window.innerHeight
                    let myBetForm = document.getElementById("betFormBtns").offsetTop
                    let myBetFormPt = document.getElementById("betFormBtns").parentNode.parentNode.offsetTop
                    if ((myBetFormPt + myBetForm) > (window.scrollY + (screenHeight / 2))) {
                        window.scrollTo(0, window.scrollY + 70)
                    }
                } else {
                    let screenHeight = window.innerHeight
                    let myBetForm = document.getElementById("betFormBtnsMob").offsetTop
                    let myBetFormPt = document.getElementById("betFormBtnsMob").parentNode.parentNode.offsetTop
                    if ((myBetFormPt + myBetForm) > (window.scrollY + (screenHeight / 2))) {
                        window.scrollTo(window.scrollY, window.scrollY + 235)
                    }
                    // let screenHeight = window.innerHeight
                    // let myBetForm = document.getElementById("betFormBtnsMob").offsetTop
                    // let yOffset = (screenHeight / 2) - window.pageYOffset + 235
                    // myBetForm = myBetForm + 235
                    // if (myBetForm < yOffset) {
                    //     window.scrollTo(0, window.scrollY + 235)
                    // } else {
                    //     window.scrollTo(0, window.scrollY)
                    // }
                }
            }
            clearTimeout(formInterval)
            formInterval = setTimeout(() => {
                if (self.state.selected_market === market && self.state.selcted_bet_option === bet) {
                    self.betForm(null, null)
                }
            }, 10000)
        })
    }
    async resultDeclered(type, payload) {
        let deactivatMarkets = this.state.deactivatMarkets
        let deactivatOrders = this.state.deactivatOrders
        let matchedBets = this.state.matched_bet
        if (type === "market") {
            if (!!payload && !!payload.marketId) {
                deactivatMarkets.push(payload.marketId)
            }
            matchedBets = matchedBets.filter((bet) => {
                return deactivatMarkets.indexOf(bet.marketId) === -1
            })
        } else if (type === "order") {
            if (!!payload && !!payload.orderId) {
                deactivatOrders.push(payload.orderId)
            }
            matchedBets = matchedBets.filter((bet) => {
                return deactivatOrders.indexOf(bet.orderId) === -1
            })
        } else if (type === "rollback") {
            let index = deactivatMarkets.indexOf(payload.marketId)
            if (index > -1) {
                deactivatMarkets = deactivatMarkets.splice(index, 1)
                matchedBets = await eventService.getMatchedBets({ "id": this.state.evetList.toString() })
                matchedBets = matchedBets.items
                matchedBets = matchedBets.filter((bet) => {
                    return deactivatMarkets.indexOf(bet.marketId) === -1
                })
                matchedBets = matchedBets.filter((bet) => {
                    return deactivatOrders.indexOf(bet.orderId) === -1
                })
            }
        }
        this.setState({ matched_bet: matchedBets, deactivatMarkets: deactivatMarkets, deactivatOrders: deactivatOrders })
    }
    toggleMultiMarket(eventId) {
        let pinnedEvents = localStorage.getItem("pinnedEvents")
        pinnedEvents = !!pinnedEvents ? pinnedEvents.split(",") : []
        let eventIndex = pinnedEvents.indexOf(eventId)
        if (eventIndex === -1) {
            pinnedEvents.push(eventId)
        } else {
            pinnedEvents.splice(eventIndex, 1)
        }
        localStorage.setItem("pinnedEvents", pinnedEvents.toString())
        let mmEvents = this.state.selectedEvents.filter((evt, i) => {
            return pinnedEvents.indexOf(evt.markets[0].marketId) > -1
        })
        this.setState({ pinnedEvents: [], selectedEvents: [] }, () => {
            this.setState({ pinnedEvents: pinnedEvents, selectedEvents: mmEvents })
        })
    }
    userPropertyUpdate(market) {
        let userMktCondition = localStorage.getItem("accountData")
        userMktCondition = JSON.parse(userMktCondition)
        if (market.marketCondition.maxBet === 0) {
            market.maxBet = userMktCondition.maxBet
        } else if (userMktCondition.maxBet === 0) {
            market.maxBet = market.marketCondition.maxBet
        } else {
            market.maxBet = market.marketCondition.maxBet
        }
        market.betDelay = Math.max(market.marketCondition.betDelay, userMktCondition.betDelay)
        return market
    }
    orderPlaced(ord) {
        let res = [ord]
        if (res[0].marketBettingType === "LINE" && res[0].marketName) {
            res[0].runnerName = res[0].marketName
        }
        if (!!res[0].marketName) {
            let deactivatMarkets = this.state.deactivatMarkets
            let deactivatOrders = this.state.deactivatOrders
            let data = res.concat(this.state.matched_bet)
            data = data.filter((bet) => {
                return deactivatMarkets.indexOf(bet.marketId) === -1
            })
            data = data.filter((bet) => {
                return deactivatOrders.indexOf(bet.orderId) === -1
            })
            const prfdt = JSON.parse(localStorage.getItem('profData'));
            if(!!prfdt && prfdt.role === 'DemoClient'){
                let demoIdSsData = sessionStorage.getItem('demoIdSsData');
                demoIdSsData = !!demoIdSsData ? JSON.parse(demoIdSsData) : {};
                demoIdSsData[this.props.match.params.event_id] = data
                sessionStorage.setItem('demoIdSsData', JSON.stringify(demoIdSsData));
                setTimeout(()=>{
                    document.getElementById('btnHdnRecalculateDemoExpo').click();
                },1000)
            }
            this.setState({ matched_bet: data, betPlaced: true })
        }
    }
    updateSubscribedMarkets(mkt) {
        let mktList = this.state.subscribedMarkets
        mktList.push(mkt)
        this.setState({ subscribedMarkets: mktList })
    }
    updateSocket(skt) {
        socket = skt
    }

    render() {
        let currencyConversion = JSON.parse(localStorage.getItem('profData')).currencyConversion
        let accData = JSON.parse(localStorage.getItem("accountData"));
        return (
            <body className="radheexch">
                <Header notify={this.props.notify} showSweetAlert={(options) => this.props.showSweetAlert(options)} MySwal={this.props.MySwal} updateBetplaceStatus={() => { this.setState({ betPlaced: false }) }} betPlaced={this.state.betPlaced} subscribe={(type, id) => { this.props.subscribe(type, id) }} subscriptions={this.props.subscriptions} history={this.props.history} socket={this.props.socket} updateSocket={(skt) => { this.updateSocket(skt) }} orderPlaced={(ord) => { this.orderPlaced(ord) }} resultDeclered={(type, payload) => { this.resultDeclered(type, payload) }} />
                <div className={`full-wrap mar-top100 footerpd ${(!!accData && Object.keys(accData).length > 0) ? '' : 'mar-top100-login mar-bottom0'}`}>
                    <Menu history={this.props.history} subscribe={(type, id) => { this.props.subscribe(type, id) }} subscriptions={this.props.subscriptions} />
                    {!!this.state.showToast && <Toast notification={this.state.toastMsg} type={this.state.toastType} />}
                    <div className="col-centersdetails markets">
                        <div className="">
                            {/* {this.state.selectedEvents.length === 0 && !this.state.loading && 
                                <div className="in-play-left pb-0">
                                    <span style={{ color: "black" }}>No selected market found.</span>
                                </div>
                            } */}
                            {this.state.selectedEvents.length === 0 && !this.state.loading &&
                                <div className='row p-2'>
                                    <div className='col-lg-12 col-md-12 col-12'>
                                        <div className='multimarketemptystate-borderdiv'>
                                            <img className='multimarketemptystate-img' src={BASE_IMAGE_PATH + "/casino/banner/images/multimarketemptystate.svg"} alt='' />
                                            <div className='flex-grow-1'>
                                                <h3 className='multimarketemptystate-color multimarketemptystate-borderdiv-h3'>
                                                    There are currently no followed multi markets.
                                                </h3>
                                                <h5 className='multimarketemptystate-color text-center'>
                                                    Please add some markets from events.
                                                </h5>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }
                            {socket !== null && this.state.selectedEvents.map((evt, i) => {
                                let market = evt.markets[0]
                                market.eventType = evt.eventType
                                return (<div className=" live-match">
                                    <div className="sub_path center-box crname">
                                        <p>
                                            <a onClick={() => { this.toggleMultiMarket(evt.markets[0].marketId) }} id="multiMarketPin" className="multimarket-pin select" style={{ "cursor": "pointer" }} title="Remove from Multi Markets"><i className="fa fa-thumb-tack" aria-hidden="true"></i></a>
                                            <span style={{ cursor: "pointer" }} onClick={() => { this.props.history.push("/event/" + evt.eventTypeId + "/" + evt.id); }}>
                                                {evt.name} ({market.eventType.id === '300' ? <>
                                                    {(market.displayMarketNameTime.length > 0 ? market.displayMarketNameTime[0] : market.catalogue.marketName)} <span className='float-right'> [Time: <b>{(market.displayMarketNameTime.length > 0 ? market.displayMarketNameTime[1] : "")}</b>]</span>
                                                </> : market.marketName})</span>
                                            {market.bettingType !== "LINE" && <span className="f-right min-max">Min: {(evt.markets[0].marketCondition.minBet / currencyConversion).toFixed(2)} | Max: {(evt.markets[0].marketCondition.maxBet / currencyConversion).toFixed(2)}</span>}
                                        </p>
                                    </div>
                                    {market.bettingType !== "LINE" && market.marketType !== "WINNING_ODDS" ?
                                        <WebMultiMarket key={market.marketId} subscribe={(type, id) => { this.props.subscribe(type, id) }} subscriptions={this.props.subscriptions} subscribedMarkets={this.state.subscribedMarkets} updateSubscribedMarkets={(mkt) => { this.updateSubscribedMarkets(mkt) }} feedBooks={this.state.mktFeedBooks} updateBook={(marketId, book) => { this.updateBook(marketId, book) }} loadingBet={this.state.loadingBet} socket={socket} curBets={this.state.matched_bet} notify={(msg, type) => { this.props.notify(msg, type) }} market={evt.markets[0]} addBet={(bet) => { bet.event_name = evt.name; this.addBet(bet, evt) }} selected_market={this.state.selected_market} selcted_bet_option={this.state.selcted_bet_option} betForm={(market, bet, clicked) => { this.betForm(market, bet, clicked) }} togglebetLoader={()=>this.setState({loadingBet: true})}/> :
                                        market.bettingType !== "LINE" && market.marketType === "WINNING_ODDS" ? <WinnerOdds key={market.marketId} subscribe={(type, id) => { this.props.subscribe(type, id) }} subscriptions={this.props.subscriptions} subscribedMarkets={this.state.subscribedMarkets} updateSubscribedMarkets={(mkt) => { this.updateSubscribedMarkets(mkt) }} feedBooks={this.state.mktFeedBooks} updateBook={(marketId, book) => { this.updateBook(marketId, book) }} loadingBet={this.state.loadingBet} socket={socket} curBets={this.state.matched_bet} notify={(msg, type) => { this.props.notify(msg, type) }} market={evt.markets[0]} addBet={(bet) => { bet.event_name = evt.name; this.addBet(bet, evt) }} selected_market={this.state.selected_market} selcted_bet_option={this.state.selcted_bet_option} betForm={(market, bet, clicked) => { this.betForm(market, bet, clicked) }} togglebetLoader={()=>this.setState({loadingBet: true})} /> :
                                            <MultiFancybook key={market.marketId} subscribe={(type, id) => { this.props.subscribe(type, id) }} subscriptions={this.props.subscriptions} subscribedMarkets={this.state.subscribedMarkets} updateSubscribedMarkets={(mkt) => { this.updateSubscribedMarkets(mkt) }} feedBooks={this.state.mktFeedBooks} updateBook={(marketId, book) => { this.updateBook(marketId, book) }} loadingBet={this.state.loadingBet} socket={socket} showExpo={(data) => { this.showExpo(data) }} curBets={this.state.matched_bet} index={i} type={"ses"} notify={(msg, type) => { this.props.notify(msg, type) }} addBet={(bet) => { bet.event_name = evt.name; this.addBet(bet, evt) }} selected_market={this.state.selected_market} selcted_bet_option={this.state.selcted_bet_option} betForm={(market, bet, clicked) => { this.betForm(market, bet, clicked) }} market={market} togglebetLoader={()=>this.setState({loadingBet: true})} />
                                    }
                                </div>)
                            })}

                            <div className="live-match livetv">
                                <div className="center-box mt-1">
                                    <div className="container-fluid titbg">
                                        <div className="w-100 float-left">
                                            <span onClick={() => { this.setState({ selected_list: "matched" }) }} className={this.state.selected_list === "matched" ? "betslip-btn active" : "betslip-btn"}>Matched Bet</span>
                                            {this.state.matched_bet.length > this.state.betLimit && <a className="view-more-btn" onClick={() => { this.setState({ betSlipOpen: true }) }} data-toggle="modal" data-target="#mystatement">View More</a>}
                                        </div>
                                    </div>
                                    {this.state.selected_list === "matched" && <div className="mybet-alldata bg-white table-responsive">
                                        <table className="table table-bordered nowrap table-sm font-12 mb-4">
                                            <thead>
                                                <tr className="bg-dark text-white">
                                                    <th>Matched Bet</th>
                                                    <th>Odds</th>
                                                    <th>Stake</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {this.state.matched_bet.map((bet, i) => {
                                                    if (i >= this.state.betLimit) {
                                                        return false
                                                    }

                                                    if (bet.eventTypeId === '300') {
                                                        bet.market_time = dateUtil.getBinaryMarketDisplayName(bet.marketName)
                                                    }
                                                    return (
                                                        <tr className={bet.side === "LAY" ? "lay-bg" : "back-bg"}>
                                                            {
                                                                bet.eventTypeId === '300' ?
                                                                    <td>{!!bet.market_time && bet.market_time.length > 0 ?
                                                                        <>
                                                                            {bet.market_time[0]}
                                                                            <small className='float-right'><b>[{bet.market_time[1]}]</b></small>
                                                                        </>

                                                                        : !!bet.marketName ? bet.marketName : "-"}</td>
                                                                    :
                                                                    <td>{bet.marketBettingType === "LINE" ? bet.runnerName + " (" + bet.price + ")" : bet.runnerName + " - " + bet.marketName}</td>
                                                            }

                                                            <td>{bet.marketBettingType === "LINE" ? bet.runnerId : bet.price}</td>
                                                            <td>{bet.amount ? bet.amount.toFixed(2) : "0.00"}</td>
                                                        </tr>
                                                    )
                                                })}
                                            </tbody>
                                        </table>
                                    </div>}
                                    {this.state.selected_list === "unmatched" && <div className="mybet-alldata bg-white table-responsive">
                                        <table className="table table-bordered nowrap table-sm font-12 mb-4">
                                            <thead>
                                                <tr className="bg-dark text-white">
                                                    <th>Matched Bet</th>
                                                    <th>Odds</th>
                                                    <th>Stake</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {this.state.unmatched_bet.map((bet) => {
                                                    return (
                                                        <tr className={bet.side === "LAY" ? "lay-bg" : "back-bg"}>
                                                            <td>{bet.marketBettingType === "LINE" ? bet.runnerName + " (" + bet.price + ")" : bet.runnerName + " - " + bet.marketName}</td>
                                                            <td>{bet.marketBettingType === "LINE" ? bet.runnerId : bet.price}</td>
                                                            <td>{bet.amount ? bet.amount.toFixed(2) : "0.00"}</td>
                                                        </tr>
                                                    )
                                                })}
                                            </tbody>
                                        </table>
                                    </div>}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={`col-right ${(!!accData && Object.keys(accData).length > 0) ? '' : 'col-right-login'}`}>
                        <div className="sub_path over-wrap">
                            <div className="center-box ">
                                <div className="container-fluid titbg">
                                    <div className="w-100 float-left">
                                        <span onClick={() => { this.setState({ selected_list: "matched" }) }} className={this.state.selected_list === "matched" ? "betslip-btn active" : "betslip-btn"}>Matched Bet</span>
                                        {this.state.matched_bet.length > this.state.betLimit && <a className="view-more-btn" onClick={() => { this.setState({ betSlipOpen: true }) }} data-toggle="modal" data-target="#mystatement">View More</a>}
                                    </div>
                                </div>
                                {this.state.selected_list === "matched" && <div className="mybet-alldata bg-white table-responsive">
                                    <table className="table table-bordered nowrap table-sm font-12 mb-4">
                                        <thead>
                                            <tr className="bg-dark text-white">
                                                <th>Matched Bet</th>
                                                <th>Odds</th>
                                                <th>Stake</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.state.matched_bet.map((bet, i) => {
                                                if (i >= this.state.betLimit) {
                                                    return false
                                                }

                                                if (bet.eventTypeId === '300') {
                                                    bet.market_time = dateUtil.getBinaryMarketDisplayName(bet.marketName)
                                                }
                                                return (
                                                    <tr className={bet.side === "LAY" ? "lay-bg" : "back-bg"}>
                                                        {
                                                            bet.eventTypeId === '300' ?
                                                                <td>{!!bet.market_time && bet.market_time.length > 0 ?
                                                                    <>
                                                                        {bet.market_time[0]}
                                                                        <small className='float-right'><b>[{bet.market_time[1]}]</b></small>
                                                                    </>

                                                                    : !!bet.marketName ? bet.marketName : "-"}</td>
                                                                :
                                                                <td>{bet.marketBettingType === "LINE" ? bet.runnerName + " (" + bet.price + ")" : bet.runnerName + " - " + bet.marketName}</td>
                                                        }
                                                        <td>{bet.marketBettingType === "LINE" ? bet.runnerId : bet.price}</td>
                                                        <td>{bet.amount ? bet.amount.toFixed(2) : "0.00"}</td>
                                                    </tr>
                                                )
                                            })}
                                        </tbody>
                                    </table>
                                </div>}
                                {this.state.selected_list === "unmatched" && <div className="mybet-alldata bg-white table-responsive">
                                    <table className="table table-bordered nowrap table-sm font-12 mb-4">
                                        <thead>
                                            <tr className="bg-dark text-white">
                                                <th>Matched Bet</th>
                                                <th>Odds</th>
                                                <th>Stake</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.state.unmatched_bet.map((bet) => {
                                                return (
                                                    <tr className={bet.side === "LAY" ? "lay-bg" : "back-bg"}>
                                                        <td>{bet.marketBettingType === "LINE" ? bet.runnerName + " (" + bet.price + ")" : bet.runnerName + " - " + bet.marketName}</td>
                                                        <td>{bet.marketBettingType === "LINE" ? bet.runnerId : bet.price}</td>
                                                        <td>{bet.amount ? bet.amount.toFixed(2) : "0.00"}</td>
                                                    </tr>
                                                )
                                            })}
                                        </tbody>
                                    </table>
                                </div>}

                            </div>
                        </div>
                    </div>
                    {this.state.showExpo && <ExpoPopup lineExpo={this.state.lineExpo} hidePopup={() => { this.hidePopup() }} />}
                    {this.state.betSlipOpen && <BetSlipPopup bets={this.state.matched_bet} hidePopup={() => { this.hidePopup() }} />}
                </div>
            </body>
        )
    }
}

function mapStateToProps(state) {
    return {
    };
}

function mapDispatchToProps(dispatch) {
    return {
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(MultiMarket);